import Vue from 'vue';

export default Vue.extend({
 template: '' +
  '<div class="ag-overlay-loading-center ag-overlay-no-rows">' +
  '<h5 class="ag-overlay-message"><i class="fas fa-exclamation"></i> {{params.noRowsMessage}}</h5>' +
  '</div>',
});
